function pauseCurrentlyPlayingVideo() {
    document.querySelectorAll('video').forEach(function(video) {
	if (!video.paused) {
	    video.pause();
	}
    });
}

export {pauseCurrentlyPlayingVideo};
